import { isBrowser } from "appConfiguration";
import type { BrandCode } from "core/entities";
import { getBrandCodeFromHost } from "./getBrandCodeFromHost";
import { getWindowHostname } from "./getWindowHostname";

// Existing CMS slugs and permission contexts still use brand short names.
export function getBrandCode(url?: string): BrandCode | undefined {
  if (url) {
    try {
      const urlObject = new URL(url);
      return getBrandCodeFromHost(urlObject.hostname);
    } catch {
      return undefined;
    }
  }
  if (!isBrowser) {
    return undefined;
  }
  const windowHostname = getWindowHostname();
  if (!windowHostname) {
    return undefined;
  }
  return getBrandCodeFromHost(windowHostname);
}
